import * as React from 'react';
import {ShowFileImageProps} from '../../../../types/mx/seminuevos/components';
import {PDF_MIME_TYPE} from '../../../../../common/constants/MimeTypeConstants';

class ShowFileImageView extends React.Component<ShowFileImageProps, {}> {
    constructor(props) {
        super(props);
    }

    render() {
        const isPDF: boolean = this.props.data.mimeType === PDF_MIME_TYPE;
        return (
            <React.Fragment>
                <div className="modal-info">
                    <div className="modal-scroll">
                        <div className="container text-center">

                            {!isPDF && <img src={this.props.data.compressUrl} className="img-fluid"/>}
                            {isPDF && <iframe src={this.props.data.compressUrl} width="100%" height={300}
                                              frameBorder="0"/>}

                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ShowFileImageView;
